import telegramUrl from '../../../shared/assets/icon/telegram.svg';
import youtubeUrl from '../../../shared/assets/icon/youtube.svg';

const SocialButtons = () => (
  <section className="content__button">
    <a
      className="content__button-primary button"
      href="https://majestic-rp.ru/register?utm_campaign=shilo"
    >
      Принять участие
    </a>
    <ul className="content__button-socials" aria-label="Социальные сети">
      <li className="content__button-socials-wrapper">
        <a
          className="content__button-social button"
          href="https://t.me/shilo_basik"
        >
          <img src={telegramUrl} alt="Telegram" />
          Telegram
        </a>
      </li>
      <li className="content__button-socials-wrapper">
        <a
          className="content__button-social button"
          href="https://youtube.com/@shilobasik"
        >
          <img src={youtubeUrl} alt="Youtube" />
          Youtube
        </a>
      </li>
    </ul>
  </section>
);

export default SocialButtons;
